/**
 * frontend/web/src/services/adminProductService.js
 * Service client pour les routes d'administration des produits
 */

import api from './api';

const adminProductService = {
  /**
   * Récupère les produits en attente d'approbation
   * @param {Object} params - { page, limit, status, etc }
   * @returns {Promise<Object>}
   */
  getPendingProducts: async (params = {}) => {
    try {
      const response = await api.get('/admin/products/pending', { params });
      return response.data;
    } catch (error) {
      console.error('[adminProductService] Error fetching pending products:', error);
      throw error;
    }
  },

  /**
   * Récupère un produit pour révision
   * @param {string|number} productId - ID du produit
   * @returns {Promise<Object>}
   */
  getProductForReview: async (productId) => {
    try {
      const response = await api.get(`/admin/products/${productId}`);
      return response.data;
    } catch (error) {
      console.error('[adminProductService] Error fetching product for review:', error);
      throw error;
    }
  },

  /**
   * Approuve un produit
   * @param {string|number} productId - ID du produit
   * @returns {Promise<Object>}
   */
  approveProduct: async (productId) => {
    try {
      const response = await api.post(`/admin/products/${productId}/approve`);
      return response.data;
    } catch (error) {
      console.error('[adminProductService] Error approving product:', error);
      throw error;
    }
  },

  /**
   * Rejette un produit
   * @param {string|number} productId - ID du produit
   * @param {Object} data - { reason: string }
   * @returns {Promise<Object>}
   */
  rejectProduct: async (productId, data) => {
    try {
      const response = await api.post(`/admin/products/${productId}/reject`, data);
      return response.data;
    } catch (error) {
      console.error('[adminProductService] Error rejecting product:', error);
      throw error;
    }
  }
};

export default adminProductService;
